import React from 'react'
import styled from 'styled-components'

import { theme, breakpoint } from '../styles'

import { SEO } from '../components'

import { MaxWidthWrapper } from '../components/layouts'

/* Containers  */
const PrivacyPolicyPageContainer = styled.section`
  background: ${theme.color.solid.white};
  color: ${theme.color.solid.pureblk};
`

const Wrapper = styled(MaxWidthWrapper)`
  margin: 0 auto;
  padding: 147px 8rem;

  @media (max-width: ${breakpoint.largeTablet}) {
    padding: 131px 7rem;
  }

  @media (max-width: ${breakpoint.largeMobile}) {
    padding: 67px 2.4rem;
  }
`
/* Headers */

const Header = styled.h2`
  text-align: center;
  margin-bottom: 0;

  @media (max-width: ${breakpoint.largeTablet}) {
    font-size: 3.8rem;
  }

  @media (max-width: ${breakpoint.largeMobile}) {
    font-size: 3.6rem;
  }
`

const LastModified = styled.h5`
  text-align: center;
  font-style: italic;
  margin-top: 8px;

  @media (max-width: ${breakpoint.largeTablet}) {
    font-size: 2.4rem;
  }

  @media (max-width: ${breakpoint.largeMobile}) {
    font-size: 1.4rem;
  }
`
/* Paragraphs */

const Paragraph = styled.p`
  font-size: 1.8rem;
  line-height: 3rem;

  @media (max-width: ${breakpoint.largeTablet}) {
    font-size: 1.4rem;
    line-height: 2.4rem;
  }

  @media (max-width: ${breakpoint.largeMobile}) {
    font-size: 1.2rem;
    line-height: 1.8rem;
  }
`

const PrivacyPolicyPage = () => (
  <>
    <SEO title="Privacy Policy" />
    <PrivacyPolicyPageContainer>
      <Wrapper>
        <Header>PRIVACY POLICY</Header>
        <LastModified>Last modified: July 1st, 2020</LastModified>
        <Paragraph>
          Katalyst Inc. (“we,” “our,” or “us”) values the privacy of individuals
          who use our websites, including katalyst.fit, and any of our other
          websites, applications, or services that link to this Privacy Policy
          (collectively, our “Services”). This Privacy Policy explains how we
          collect, use, and share personal information from users and other
          individuals of our Services (collectively, “you” or “your”). By using
          our Services, you agree that we will collect, use, and share your
          personal information as described in this Privacy Policy. Beyond this
          Privacy Policy, your use of our Services is also subject to our Terms
          of Service.
        </Paragraph>

        <Paragraph>How We Collect Personal Information</Paragraph>

        <Paragraph>
          We may collect a variety of personal information from or about you or
          your devices from various sources, as described below.
        </Paragraph>

        <Paragraph>
          If you do not provide your personal information when requested, you
          may not be able to use our Services if that personal information is
          necessary to provide you with our Services or if we are legally
          required to collect it.
        </Paragraph>

        <Paragraph>A. Personal Information You Provide to Us. </Paragraph>

        <Paragraph>
          Registration Information. When you sign up for an account to use our
          Services, we will ask you for your personal information, including
          your first and last name, email address, phone number, username, and
          password.
        </Paragraph>

        <Paragraph>
          Information Provided by your use of the Services and EMS Suit. Once
          you begin using the Katalyst Training System, we may collect
          additional personal information about you, including your weight,
          height, date-of-birth, gender, fitness profile (including your fitness
          goals and activity levels), and information about your workouts
          provided to us by your EMS suit.
        </Paragraph>

        <Paragraph>
          Purchases. When you purchase products or Services from us, we will
          collect personal information from you including your name, email
          address, mailing address, phone number, and sizing and body
          information such as your size, height, weight, and age. Your credit
          card information, billing information, or any other financial
          information necessary to complete your purchase (“Payment
          Information”) is processed by our third-party payment processors, and
          we do not collect, store, or process your Payment Information. For
          more information, please see the “Payment Processors” section below.
        </Paragraph>

        <Paragraph>
          Communications. If you contact us directly, we may receive additional
          personal information about you. For example, when you contact us for
          support, we will receive your [first and last name, email address, and
          the contents of your communication]. If you subscribe to our marketing
          communications, we will collect personal information from you such as
          your [name and email address]. When we send you emails, we may [track
          whether you open them to learn how to deliver a better customer
          experience and improve our Services].
        </Paragraph>

        <Paragraph>
          Careers. If you decide to apply for a job with us, you may submit your
          contact information and your resume online. We will collect the
          personal information you choose to provide on your resume, such as
          your education and employment experience. You may also apply through
          certain third-party websites. If you do so, we will collect the
          personal information you make available to us through those websites.
        </Paragraph>

        <Paragraph>
          B. Personal information We Collect When You Use our Services.
        </Paragraph>

        <Paragraph>
          Location Information. When you use our Services, if you allow us, we
          may collect location-based information including your Internet
          Protocol (IP) address, city, region, and country. We use
          location-based information to enhance your user experience, provide
          you with information on workout trends in your region, and to better
          understand where and how you and others are using our Services.
        </Paragraph>

        <Paragraph>
          Device Information. We receive information about the device and
          software you use to access our Services, including your IP address,
          web browser type, operating system version, phone carrier and
          manufacturer, application installations, device identifiers,
          geolocation information, mobile advertising or similar identifiers,
          and push notification tokens.
        </Paragraph>
        <Paragraph>
          Usage Information. To help us understand how you use our Services and
          to help us improve them, we automatically receive information about
          your interactions with them, such as [the pages or other content you
          view, the content you post, the information you upload, the searches
          you conduct, the length of time you spend on a page, objects such as
          hyperlinks you click on, and the dates and times of your visits].
        </Paragraph>

        <Paragraph>
          Information from Cookies and Similar Technologies. We and our
          third-party partners may collect information using cookies, pixel
          tags, or similar technologies. Our third-party partners, such as
          analytics and advertising partners, may use these technologies to
          collect information about your online activities over time and across
          different services. Cookies are small text files containing a string
          of alphanumeric characters. We may use both session cookies and
          persistent cookies. A session cookie disappears after you close your
          browser. A persistent cookie remains after you close your browser and
          may be used by your browser on subsequent visits to our Services.
        </Paragraph>

        <Paragraph>
          Please review your web browser’s “Help” file to learn the proper way
          to modify your cookie settings. Please note that if you delete or
          choose not to accept cookies from the Service, you may not be able to
          utilize the features of the Service to their fullest potential.
        </Paragraph>

        <Paragraph>
          C. Personal Information We Receive from Third Parties.
        </Paragraph>

        <Paragraph>
          We may receive personal information about you from third parties such
          as data, marketing, financing, or retail partners and combine it with
          other personal information we have about you.
        </Paragraph>

        <Paragraph>D. Payment Processors. </Paragraph>

        <Paragraph>
          When you make a purchase through our Services, your payment is
          processed by a third-party service such as [the App Store] or, in the
          case of purchases made through our website, a third-party payment
          processor such as [Shopify and Google Pay]. These third parties may
          collect personal information from you, including your [name, email
          address, shipping information, and Payment Information] in connection
          with your purchase. If you decide to use any of our financing options,
          you will be asked to provide [your personal information, which may
          include Payment Information, to our financing partners]. The use of
          your personal information by these third parties is governed by their
          terms and conditions and privacy policies, and personal information we
          receive about you from these third parties is governed by this Privacy
          Policy.
        </Paragraph>

        <Paragraph>How We Use the Personal Information We Collect</Paragraph>
        <Paragraph>We use the personal information we collect:</Paragraph>

        <Paragraph>To provide the Services and products;</Paragraph>

        <Paragraph>
          To understand and analyze how you use our Services and develop new
          products, services, features, and functionality;
        </Paragraph>

        <Paragraph>
          To communicate with you, provide you with updates and other
          information relating to our Services, provide information that you
          request, respond to comments and questions, and otherwise provide
          customer support;
        </Paragraph>

        <Paragraph>
          To facilitate the connection of third-party services or applications;
        </Paragraph>

        <Paragraph>
          For marketing and advertising purposes, such as developing and
          providing promotional and advertising materials that may be relevant,
          valuable, or otherwise of interest to you;
        </Paragraph>

        <Paragraph>To facilitate transactions or payments;</Paragraph>

        <Paragraph>
          To generate de-identified or aggregated data for our business
          purposes;
        </Paragraph>

        <Paragraph>To send you push notifications and text messages;</Paragraph>

        <Paragraph>
          To find and prevent fraud, and respond to trust and safety issues that
          may arise;
        </Paragraph>

        <Paragraph>
          For compliance purposes, including enforcing our Terms of Service or
          other legal rights, as may be required by applicable laws and
          regulations, or as requested by any judicial process or governmental
          agency; and
        </Paragraph>

        <Paragraph>
          For other purposes for which we provide specific notice at the time
          the personal information is collected.
        </Paragraph>

        <Paragraph>How We Share the Personal Information We Collect</Paragraph>

        <Paragraph>
          We do not share or otherwise disclose your personal information except
          as described below or otherwise disclosed to you at the time of the
          collection.
        </Paragraph>
        <Paragraph>
          Affiliates. We may share any personal information we receive with our
          affiliates for any of the purposes described in this Privacy Policy.
        </Paragraph>
        <Paragraph>
          Vendors and Service Providers. We may share personal information we
          receive with vendors and service providers retained in connection with
          the provision of our Services.
        </Paragraph>
        <Paragraph>
          Marketing. We do not rent, sell, or share personal information about
          you with nonaffiliated companies for their direct marketing purposes
          unless we have your permission.
        </Paragraph>
        <Paragraph>
          Marketing Partners. We may share your personal information with our
          marketing partners such as HubSpot to manage and send emails to you on
          our behalf.
        </Paragraph>
        <Paragraph>
          Analytics Partners. We may use analytics services such as [Mixpanel,
          Google Analytics, and Firebase] to collect and process certain
          analytics data. These services may also collect information about your
          use of other websites, apps, and online resources.
        </Paragraph>

        <Paragraph>
          Advertising Partners. We work with third party advertising partners to
          show you ads that we think may interest you. Some of our advertising
          partners are members of the Network Advertising Initiative
          (http://optout.networkadvertising.org/?c=1#!/) or the Digital
          Advertising Alliance (http://optout.aboutads.info/?c=2&lang=EN). If
          you do not wish to receive personalized ads, please visit their
          opt-out pages to learn about how you may opt out of receiving
          web-based personalized ads from member companies. You can access any
          settings offered by your mobile operating system to limit ad tracking,
          or you can install the AppChoices mobile app to learn more about how
          you may opt out of personalized ads in mobile apps.
        </Paragraph>

        <Paragraph>
          As Required by Law and Similar Disclosures. We may access, preserve,
          and disclose your personal information if we believe doing so is
          required or appropriate to: (a) comply with law enforcement requests
          and legal process, such as a court order or subpoena; (b) respond to
          your requests; or (c) protect your, our, or others’ rights, property,
          or safety. For the avoidance of doubt, the disclosure of your personal
          information may occur if you send any objectionable content on or
          through our Services.
        </Paragraph>
        <Paragraph>
          Merger, Sale, or Other Asset Transfers. We may transfer your personal
          information to service providers, advisors, potential transactional
          partners, or other third parties in connection with the consideration,
          negotiation, or completion of a corporate transaction in which we are
          acquired by or merged with another company or we sell, liquidate, or
          transfer all or a portion of our assets.
        </Paragraph>

        <Paragraph>
          Consent. We may also disclose your personal information with your
          permission.
        </Paragraph>

        <Paragraph>Your Choices</Paragraph>

        <Paragraph>
          Location Information. You can prevent your device from sharing precise
          location information at any time through your device’s operating
          system settings. However, location is core to our Services and without
          it, we may not be able to provide with all the functionality our
          Services.
        </Paragraph>
        <Paragraph>
          Marketing Communications. You can unsubscribe from our promotional
          emails via the link provided in the emails. Even if you opt-out of
          receiving promotional messages from us, you will continue to receive
          administrative messages from us.
        </Paragraph>
        <Paragraph>
          Do Not Track. There is no accepted standard on how to respond to Do
          Not Track signals, and we do not respond to such signals.
        </Paragraph>

        <Paragraph>
          Third PartiesOur Services may contain links to other websites,
          products, or services that we do not own or operate. We are not
          responsible for the privacy practices of these third parties. Please
          be aware that this Privacy Policy does not apply to your activities on
          these third-party services or any information you disclose to these
          third parties. We encourage you to read their privacy policies before
          providing any information to them.
        </Paragraph>

        <Paragraph>Security</Paragraph>
        <Paragraph>
          We make reasonable efforts to protect your personal information by
          using physical and electronic safeguards designed to improve the
          security of the personal information we maintain. However, as no
          electronic transmission or storage of personal information can be
          entirely secure, we can make no guarantees as to the security or
          privacy of your personal information.
        </Paragraph>

        <Paragraph>Children’s Privacy</Paragraph>
        <Paragraph>
          We do not knowingly collect, maintain, or use personal information
          from children under 13 years of age, and no part of our Services are
          directed to children. If you learn that a child has provided us with
          personal information in violation of this Privacy Policy, you may
          alert us at support@katalyst.fit.
        </Paragraph>

        <Paragraph>International Visitors</Paragraph>
        <Paragraph>
          Our Services are hosted in the United States and intended for visitors
          located within the United States. If you choose to use our Services
          from the European Union or other regions of the world with laws
          governing data collection and use that may differ from U.S. law, then
          please note that you are transferring your personal information
          outside of those regions to the United States for storage and
          processing. Also, we may transfer your data from the U.S. to other
          countries or regions in connection with storage and processing of
          data, fulfilling your requests, and operating the Services. By
          providing any information, including personal information, on or to
          our Services, you consent to such transfer, storage, and processing.
        </Paragraph>

        <Paragraph>Update Your Information or Pose a Question</Paragraph>
        <Paragraph>
          You can update your account and profile information through your
          profile settings. If you have questions about your privacy on our
          Services or this privacy policy, please contact us at
          support@katalyst.fit.
        </Paragraph>

        <Paragraph>Changes to this Privacy Policy</Paragraph>
        <Paragraph>
          We will post any adjustments to the Privacy Policy on this page, and
          the revised version will be effective when it is posted. If we
          materially change the ways in which we use or share personal
          information previously collected from you through our Services, we
          will attempt to notify you through our Services, by email, or other
          means.
        </Paragraph>

        <Paragraph>Contact Information</Paragraph>
        <Paragraph>
          If you have any questions, comments, or concerns about our processing
          activities, please email us at support@katalyst.fit or write to us at
          Katalyst Inc, 1201 Third Avenue, Suite 2200, Seattle, WA, US, 98101.
        </Paragraph>
      </Wrapper>
    </PrivacyPolicyPageContainer>
  </>
)

export default PrivacyPolicyPage
